




































import { defineComponent, PropType } from '@vue/composition-api';
import { dtFormat } from '@/lib/dateHelper';
import type { ExternalReportSettings } from '@/models/apis/externalReports/external_report_settings';

export default defineComponent({
  props: {
    userSettings: {
      type: Object as PropType<ExternalReportSettings>,
      required: true,
    },
    isRealtimeMode: {
      type: Boolean,
      default: false,
    },
    carsUpdatedAt: {
      type: Date,
    },
    movingCarsCount: {
      type: Number,
      default: 0,
    },
    stoppedCarsCount: {
      type: Number,
      default: 0,
    },
  },
  setup() {
    return {
      dtFormat,
    };
  },
});
